import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { AccountRequests } from './account-request-list';
import { v2Component } from '../../../index';

export function initAccountRequestList() {
  document.getElementsByName('account-resquests').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <AccountRequests />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
